import type { ReactNode } from 'react';

export const symbol_tv_gen: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m220-200-24 72q-2 4-4.61 6-2.61 2-6.26 2H182q-4.8 0-8.4-3.6-3.6-3.6-3.6-8.4v-68h-30q-24.75 0-42.37-17.63Q80-235.25 80-260v-480q0-24.75 17.63-42.38Q115.25-800 140-800h680q24.75 0 42.38 17.62Q880-764.75 880-740v480q0 24.75-17.62 42.37Q844.75-200 820-200h-30v69q0 4.63-3.17 7.82-3.18 3.18-7.79 3.18H775q-4 0-6.5-2.15-2.5-2.16-3.5-5.85l-24-72H220Zm-80-60h680v-480H140v480Zm340-240Z"
		/>
	</svg>
);
